export const ROOT_CLASS = 'ws-ui-gradient-stops-slider';
export const RANGE_CLASS = `${ROOT_CLASS}__range`;
export const HANDLE_CLASS = `${ROOT_CLASS}__handle`;
export const HANDLE_ACTIVE_CLASS = `${HANDLE_CLASS}--active`;

export const RC_SLIDER_PREFIX_CLASS = 'rc-slider';
export const RC_SLIDER_RAIL_SELECTOR = `.${RC_SLIDER_PREFIX_CLASS}-rail`;
export const RC_SLIDER_HANDLE_SELECTOR = `.${RC_SLIDER_PREFIX_CLASS}-handle`;

export const MIN_POSITION = 0;
export const MAX_POSITION = 100;
export const POSITION_STEP = 1;

export const GRADIENT_STOPS_RAIL_BACKGROUND_CSS_VAR = '--gradient-stops-rail-background';
export const GRADIENT_STOPS_HANDLE_OFFSET_CSS_VAR = '--gradient-stops-handle-offset';
